<ion-header>
  <ion-toolbar>
    <ion-title mode="ios">Enregistrement Vocal</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancelRecording()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>


<ion-content>
  <div class="c-full-content-div">
    <div class="c-center-infos">
      <ion-button shape="round" class="c-audio-button" (click)="recording ? stopRecording() : startRecording()" >
        <ion-icon [name]="recording ? 'mic-off-outline' : 'mic-outline'"></ion-icon>
      </ion-button>
      <div class="c-record-time">
        {{ timeRecording | timeFormatPipe:'ms' }} - {{ timeLimit | timeFormatPipe:'s' }}
      </div>
    </div>
  </div>
</ion-content>